export enum CacheKeys {
  region = 'location-state',
  openDrawer = 'openDrawer'
}
